module.exports = __webpack_public_path__ + "static/js/session.2a250363.chunk.worker.js"